var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPwOn = function SvgIcPwOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.043c-3.87 0-7.248 2.084-9.1 5.174a.75.75 0 0 0 0 .771c1.852 3.09 5.23 5.175 9.1 5.175a.752.752 0 0 0 .13-.011c3.817-.047 7.14-2.119 8.97-5.174a.75.75 0 0 0 0-.772c-1.852-3.08-5.23-5.163-9.1-5.163Zm0 9.61a.748.748 0 0 0-.121.01c-3.105-.042-5.833-1.645-7.448-4.06 1.636-2.446 4.414-4.06 7.57-4.06 3.154 0 5.932 1.613 7.568 4.05-1.636 2.446-4.414 4.06-7.569 4.06Zm-2.285-4.05a2.284 2.284 0 1 1 4.568 0 2.284 2.284 0 0 1-4.568 0Zm2.284-3.784a3.784 3.784 0 1 0 0 7.568 3.784 3.784 0 0 0 0-7.568Z"
  })));
};
export default SvgIcPwOn;